<template>
  <b-container fluid class="mb-6 mt-6 p-0">
    <b-row>
      <b-col>
        <div class="card card-custom gutter-b">
          <div class="mt-0">
            <template-table
              :column="column"
              :data="data"
              :highlight-id="highlightId"
              :paging="paging"
              :tableAction="false"
              :selectAction="false"
              :searchAction="false"
            >
              <template v-slot:body="{ item }">
                <td>
                  <span class="font-weight-bolder">
                    {{ $moment(item.date * 1000).format('DD/MM/YYYY') }}
                  </span>
                </td>
                <td>
                  <span
                    :style="`color:${item.color}`"
                    class="font-weight-bolder"
                  >
                    {{ item.hbA1C }}%
                  </span>
                </td>
                <td>
                  <span class="font-weight-bolder">
                    {{ item.description }}</span
                  >
                </td>
                <td>
                  <div class="d-flex">
                    <div
                      class="preview"
                      v-for="(image, index) in item.images"
                      :key="index"
                    >
                      <img
                        @click.stop="handlePreview(image.url)"
                        :src="image.url"
                        class="preview-image"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
              </template>
            </template-table>
          </div>
          <image-preview :image.sync="imagePreview" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { fetchAllPages } from '../exportExcel';
export default {
  name: 'Hba1cTable',
  components: {
    'image-preview': () => import('../components/ModalPreview.vue'),
  },
  props: {
    time: {
      type: Object,
    },
    idUser: {
      type: [String, Number],
    },
    highlightId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      column: [
        {
          key: 'date',
          label: 'Ngày nhập',
          sortable: false,
        },
        {
          key: 'hbA1C',
          label: 'Kết quả',
          sortable: false,
        },
        {
          key: 'description',
          label: 'Ghi chú',
          sortable: false,
        },
        {
          key: 'thumbnail',
          label: 'Hình ảnh',
          sortable: false,
        },
      ],
      data: [],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        currentDateTime: parseInt(new Date().getTime() / 1000),
        periodFilterType: 1,
      },
      imagePreview: null,
    };
  },
  computed: {
    id() {
      return this.idUser;
    },
  },
  watch: {
    paging: {
      handler(newVal) {
        if (newVal) {
          this.loadData();
        }
      },
      deep: true,
    },
    time: {
      handler(newVal) {
        this.searchParams.periodFilterType = newVal.value;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async exportRows() {
      const data = await fetchAllPages(this.$api, 'Admin/HbA1C/Input', {
        ...this.searchParams,
        patientId: this.id,
      });
      return {
        columns: ['Ngày nhập', 'HbA1c (%)', 'Ghi chú', 'Hình ảnh'],
        rows: (data || []).map((e) => [
          this.$moment(e.date * 1000).format('DD/MM/YYYY'),
          e.hbA1C,
          e.description,
          (e.images || []).map((i) => i.url).join('\n'),
        ]),
      };
    },
    handlePreview(image) {
      this.imagePreview = image;
      this.$bvModal.show('image-preview');
    },

    loadData() {
      this.$store.commit('context/setLoading', true);
      this.$api
        .get('Admin/HbA1C/Input', {
          params: {
            ...this.searchParams,
            ...this.paging,
            size: this.paging.pageSize,
            patientId: this.id,
          },
        })
        .then(({ meta, data }) => {
          this.data = data || [];

          this.paging.total = meta.total;
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        })
        .finally(() => {
          this.$store.commit('context/setLoading', false);
        });
      return;
    },
  },
};
</script>

<style lang="scss">
.preview {
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.preview:not(:first-child) {
  margin-left: 10px;
}
.preview-image {
  border-radius: 6px;
  display: block;
  width: 100%;
  object-fit: cover;
  height: 100%;
}
</style>
